import {
	connect
} from 'react-redux'
import DataTable from '../components/common/DataTable.jsx';
import {
	findFittingBatchList,
	changeFittingBatchActivePage,
	deleteBatchItems, 
	openFittingBatchModal, 
} from '../actions';

function checkShowCheckBox(roles) {
	return (roles.includes("ROLE_FIREFIGHTER_FITTING_CRUD"));
}

function checkDisableAdd(roles) {
	return !(roles.includes("ROLE_FIREFIGHTER_FITTING_CRUD"));
}

const mapStateToProps = (state) => ({
	orderId: state.getIn(['fittingReducer', 'orderId']),
	data: state.getIn(['fittingBatchListReducer', 'fittingBatchList']),
	activePage: state.getIn(['fittingBatchListReducer', 'activePage']),
	itemPerPage: state.getIn(['fittingBatchListReducer', 'itemPerPage']),
	totalPage: state.getIn(['fittingBatchListReducer', 'totalPage']),
	pagingMaxButtons: 5,
	fields: {
		category: '群組',
		display_name: '類別',
		firefighter_corporation: '單位',
		firefighter_division: '大隊',
		firefighter_squadron: '分隊',
		customer_gear_name: '項目',
		color_display: '顏色',
		sizing_display: '尺寸',
		cnt: '件數',
		is_spare_parts: '備品'
	},
	keys: ['orderer_id', 'order_detail_id', 'color', 'sizing'],
	// showCheckBox: true,
	showCheckBox: checkShowCheckBox(state.getIn(['authReducer', 'roles']).toJS()),
	disableAdd: checkDisableAdd(state.getIn(['authReducer', 'roles']).toJS()),
	disableEdit: true
})

const mapDispatchToProps = (dispatch, ownProps) => ({
	refresh: (pagingData) => {
		dispatch(findFittingBatchList({orderId: ownProps.orderId}, pagingData));
	},
	changeActivepage: (pagingData) => {
		dispatch(changeFittingBatchActivePage(pagingData));
		dispatch(findFittingBatchList({orderId: ownProps.orderId}, pagingData));
	},
	deleteItems:(deleteKey, pagingData) => {
		dispatch(deleteBatchItems({orderId: ownProps.orderId}, deleteKey, pagingData));
	},
	openAddModal:() => {
		dispatch(openFittingBatchModal());
	},
})

const FittingBatchListContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(DataTable)

export default FittingBatchListContainer;


// WEBPACK FOOTER //
// ./src/containers/FittingBatchListContainer.jsx